import templateUrl from 'emun.salesrep/salesrepgroup-dashboard.htm'
import SalesRepGroupDashboardController from 'emun.salesrep/salesrepgroup-dashboard.controller'



let SalesRepGroupDashboard = {
	bindings: {
		repId: '@',
		rep: '@'
	},
	require: {
		container: '^salesrepContainer'
	},
	controller: SalesRepGroupDashboardController,
	templateUrl($element, $attrs) {
		return $attrs.templateUrl || templateUrl
	}
}

export default SalesRepGroupDashboard